import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useMembershipExpiration from "../../hooks/useMembershipExpiration";
import { setStatusMembership } from "../../redux/slice/membershipSlice";

const ModalAlertStatusMembership = () => {
  const { nextPayment, membershipStatus, planName } = useSelector(
    (state) => state.membershipReducer
  );
  const { isExpired, isAboutToExpire, expiresToday, daysRemaining } =
    useMembershipExpiration(nextPayment, planName);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (membershipStatus !== "active") {
      return;
    }

    if (isExpired) {
      dispatch(setStatusMembership({ membershipStatus: "inactive" }));
      setOpen(true);
    }
    if (isAboutToExpire || expiresToday) {
      setOpen(true);
    }
  }, [isAboutToExpire, isExpired, expiresToday]);

  return (
    <Dialog
      open={open ?? false}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      sx={{ zIndex: 9999 }}
    >
      {expiresToday ? (
        <DialogTitle>¡Tu membresía vence hoy!</DialogTitle>
      ) : isExpired ? (
        <DialogTitle>¡Tu membresía ha vencido!</DialogTitle>
      ) : isAboutToExpire ? (
        <DialogTitle>¡Atención!</DialogTitle>
      ) : null}

      <DialogContent>
        {expiresToday ? (
          <Typography>
            ¡Hoy es el último día de tu membresía! Renueva ahora para evitar
            interrupciones.
          </Typography>
        ) : isExpired ? (
          <Typography>
            Tu membresía lleva {Math.abs(daysRemaining)} día
            {Math.abs(daysRemaining) !== 1 ? "s" : ""} vencida. Por favor
            renueva para reactivar tus beneficios.
          </Typography>
        ) : isAboutToExpire ? (
          <Typography>
            Tu membresía vence en {daysRemaining} día
            {daysRemaining !== 1 ? "s" : ""}. No olvides renovarla a tiempo.
          </Typography>
        ) : null}
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={handleClose}
        >
          Aceptar
        </Button>
        <Button
          variant="outlined"
          color="#e7ef7d"
          onClick={() => navigation("/dashboard/account")}
        >
          Pagar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAlertStatusMembership;
